import React from 'react';
import { Typography } from '@material-ui/core';

import { PrimaryButton, TextField } from '../../components/AtomComponents';

import { IInputsState } from './usePxwSelectionInputs';

interface IPxwQuantityInputsProps {
  formInputs: IInputsState;
  totalQty: number;
  receivedQty: number;
  isSubmitDisabled: boolean;
  showValidationHint: boolean;
  onMatchChange: (v: number | '') => void;
  onMismatchFunctionalChange: (v: number | '') => void;
  onMismatchNonFunctionalChange: (v: number | '') => void;
  onSubmit: () => void;
}

const parseQty = (v: string): number | '' => (v === '' ? '' : Math.max(0, Number(v)));

const PxwQuantityInputs: React.FC<IPxwQuantityInputsProps> = ({
  formInputs,
  totalQty,
  receivedQty,
  isSubmitDisabled,
  showValidationHint,
  onMatchChange,
  onMismatchFunctionalChange,
  onMismatchNonFunctionalChange,
  onSubmit,
}) => {
  return (
    <>
      <div className="margin-top-1">
        <p className="text-faded">
          Enter quantities per test result category. Total must equal the item's received quantity.
        </p>
        <div className="grid-x grid-margin-x grid-margin-y">
          <div className="cell small-12 medium-4">
            <TextField
              label="Match"
              type="number"
              variant="outlined"
              fullWidth
              disabled={!formInputs.selectedItem}
              value={formInputs.matchQty}
              inputProps={{ min: 0 }}
              onChange={(e) => onMatchChange(parseQty(e.target.value))}
            />
          </div>
          <div className="cell small-12 medium-4">
            <TextField
              label="Mismatch — Functional"
              type="number"
              variant="outlined"
              fullWidth
              disabled={!formInputs.selectedItem}
              value={formInputs.mismatchFunctionalQty}
              inputProps={{ min: 0 }}
              onChange={(e) => onMismatchFunctionalChange(parseQty(e.target.value))}
            />
          </div>
          <div className="cell small-12 medium-4">
            <TextField
              label="Mismatch — Non-Functional"
              type="number"
              variant="outlined"
              fullWidth
              disabled={!formInputs.selectedItem}
              value={formInputs.mismatchNonFunctionalQty}
              inputProps={{ min: 0 }}
              onChange={(e) => onMismatchNonFunctionalChange(parseQty(e.target.value))}
            />
          </div>
        </div>
      </div>
      <div className="cell margin-top-1 margin-bottom-1">
        {showValidationHint && (
          <Typography
            variant="caption"
            color={totalQty === receivedQty ? 'textSecondary' : 'error'}
            className="pxw-process-devices__validation-hint">
            Total: {totalQty} / {receivedQty} received
            {totalQty < receivedQty && ' — must equal received quantity'}
            {totalQty > receivedQty && ' — exceeds received quantity'}
          </Typography>
        )}
        <PrimaryButton
          size="small"
          className="margin-top-1"
          disabled={isSubmitDisabled}
          onClick={onSubmit}>
          Generate Test Data
        </PrimaryButton>
      </div>
    </>
  );
};

export default PxwQuantityInputs;
